import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IYearMonth } from '@/coreDomainsModule/date';
import {
  ForecastForReceiptHeaderKey,
  isCustomerForecastWithDiffLastMonthKey,
  TableContentProperty,
} from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import SupplierForecastCreationStatusIcon from './SupplierForecastCreationStatusIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { computed } from 'vue';
import ForecastForReceiptTableCell from './ForecastForReceiptTableCell.vue';
import ForecastDiffLastMonthTableCell from './ForecastDiffLastMonthTableCell.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerForecastTableCellWrapper',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    forecastStartYearMonth: { default: undefined },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow", "onClickTransitionTimeline", "onClickTransactionList", "onClickDownload", "onClickForecastRequestMail", "onClickEdit", "onClickRemoveFromForecast"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const forecastForReceiptTableContentVM = new ForecastForReceiptTableContentViewModel();

const textAlign = computed(() => {
  if (props.header.key === 'SupplierForecastCreateStatus') {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_unref(isCustomerForecastWithDiffLastMonthKey)(_ctx.header.key))
    ? (_openBlock(), _createBlock(ForecastDiffLastMonthTableCell, {
        key: 0,
        header: _ctx.header,
        "header-key": _ctx.headerKey,
        item: _ctx.item,
        "header-index": _ctx.headerIndex,
        "accumulation-table-content-width": _ctx.accumulationTableContentWidth,
        "is-variable-width": _ctx.isVariableWidth,
        "is-all-selected": _ctx.isAllSelected,
        "stable-column-count": _ctx.stableColumnCount,
        "is-bold": _ctx.isBold,
        "forecast-start-year-month": _ctx.forecastStartYearMonth,
        "is-checked": props.isChecked,
        "is-checked-business-id": props.isCheckedBusinessId,
        onOnClickNarrow: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickNarrow')))
      }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "forecast-start-year-month", "is-checked", "is-checked-business-id"]))
    : (_openBlock(), _createBlock(ForecastForReceiptTableCell, {
        key: 1,
        header: _ctx.header,
        "header-key": _ctx.headerKey,
        item: _ctx.item,
        "header-index": _ctx.headerIndex,
        "accumulation-table-content-width": _ctx.accumulationTableContentWidth,
        "is-variable-width": _ctx.isVariableWidth,
        "is-all-selected": _ctx.isAllSelected,
        "stable-column-count": _ctx.stableColumnCount,
        "is-bold": _ctx.isBold,
        "forecast-start-year-month": _ctx.forecastStartYearMonth,
        "is-checked": props.isChecked,
        "is-checked-business-id": props.isCheckedBusinessId,
        onOnClickNarrow: _cache[1] || (_cache[1] = ($event: any) => (emits('onClickNarrow'))),
        onOnClickTransitionTimeline: _cache[2] || (_cache[2] = ($event: any) => (emits('onClickTransitionTimeline'))),
        onOnClickTransactionList: _cache[3] || (_cache[3] = ($event: any) => (emits('onClickTransactionList'))),
        onOnClickDownload: _cache[4] || (_cache[4] = ($event: any) => (emits('onClickDownload'))),
        onOnClickForecastRequestMail: _cache[5] || (_cache[5] = ($event: any) => (emits('onClickForecastRequestMail'))),
        onOnClickEdit: _cache[6] || (_cache[6] = ($event: any) => (emits('onClickEdit'))),
        onOnClickRemoveFromForecast: _cache[7] || (_cache[7] = ($event: any) => (emits('onClickRemoveFromForecast')))
      }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "forecast-start-year-month", "is-checked", "is-checked-business-id"]))
}
}

})